import { Gender } from "@/model/gender";
import PlayerStore from "@/store/player";
import { Player, PlayerMarker, ScenarioMarker } from "@/store/player/types";
import {Settings} from "@/constants/settings";

export default class PlayerUtils {

    public static getGender(player: Player): Gender {
        let companionImage: string = player.companionImage;
        if (companionImage != null && companionImage.includes("female")) {
            return Gender.female;
        }
        return Gender.male;
    }

    public static hasMarker(marker: String): Boolean {
        return PlayerStore.getPlayer().playerMarkers.some((m: PlayerMarker) => m.playerMarker == marker);
    }

    public static hasScenarioMarker(marker: String): Boolean {
        return PlayerStore.getPlayer().scenarioMarkers.some((m: ScenarioMarker) => m.scenarioMarker == marker);
    }

    public static getStartVersion() {
        let player = PlayerStore.getPlayer();
        if (player) {
            return player.versionStart;
        } else {
            return Settings.DEFAULT_START_VERSION;
        }
    }

    /**
     * Стартовые версии, на которых сервер создаёт бой прямо в registerTrial: такой новичок
     * попадает в бой сразу из выбора персонажа, минуя дорогу. На остальных версиях бой
     * появляется только после атаки места на дороге.
     */
    private static readonly START_VERSIONS_WITH_INSTANT_BATTLE: Set<number> =
        new Set<number>([6, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18]);

    public static startsWithBattle(): boolean {
        return PlayerUtils.START_VERSIONS_WITH_INSTANT_BATTLE.has(PlayerUtils.getStartVersion());
    }
}
